module.exports = {
    "baseUrl": "https://abb-onboarding-api.albo.live",
    "hubspotTrackerCode": "5938580",
    "googleAnalyticsTrackingId": "UA-237500367-1",
    "inextUrl": "https://in-web.albo.live/"
}